var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "미팅관리",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('div', {
    staticClass: "applied-cards"
  }, _vm._l(_vm.items, function (item) {
    return _c('schedule-list-item', {
      key: item._id,
      attrs: {
        "value": item
      },
      on: {
        "input": _vm.updateItem
      }
    });
  }), 1), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요. "), _c('br'), _vm._v(" 요청된 미팅이 없습니다. ")]), _c('v-btn', {
    attrs: {
      "href": "/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용공고 지원하기")])])], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }